import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {

  constructor(
      private router: Router,
      private commonService: CommonService,
      private activatedRoute: ActivatedRoute
  ) { 
    let user: User = this.commonService.getUserInfo()
    this.userId = user.userId
    this.isAdmin = user.isAdmin 
    if(this.isAdmin) {
      //home
      let home: MenuGroup = new MenuGroup()
      home.name = 'HOME'
      home.iconClass = 'lnb_list-00'
      home.isHome = true
      this.menuGroupList.push(home)
      //회원관리
      let userGroup: MenuGroup = new MenuGroup()
      userGroup.name = '회원관리'
      userGroup.iconClass = 'lnb_list-05'
      userGroup.list.push(new Menu('회원 목록', '/user/list'))
      this.menuGroupList.push(userGroup)
      //정산관리
      let myPageGroup1: MenuGroup = new MenuGroup()
      myPageGroup1.name = '정산관리'
      myPageGroup1.iconClass = 'lnb_list-06'
      myPageGroup1.list.push(new Menu('정산 현황', '/settle/list'))
      myPageGroup1.list.push(new Menu('상세 내역', '/settle/link/history'))
      myPageGroup1.list.push(new Menu('이체 내역', '/settle/transfer/history'))
      //myPageGroup1.list.push(new Menu('상세내역', '/settle/history'))
      //myPageGroup1.list.push(new Menu('상세내역', '/settle/history'))
      //myPageGroup1.list.push(new Menu('취소내역', null))
      //링크관리
      let linkGroup: MenuGroup = new MenuGroup()
      linkGroup.name = '링크관리'
      linkGroup.iconClass = 'lnb_list-02'
      linkGroup.list.push(new Menu('링크 목록', '/link/list'))
      this.menuGroupList.push(linkGroup)
      this.menuGroupList.push(myPageGroup1)
      let voc: MenuGroup = new MenuGroup()
      voc.name = '고객의 소리'
      voc.iconClass = 'lnb_list-04'
      voc.list.push(new Menu('공지', '/voc/NOTICE/list'))
      voc.list.push(new Menu('문의', '/voc/QNA/list'))
      voc.list.push(new Menu('FAQ', '/voc/FAQ/list'))
      voc.list.push(new Menu('이용가이드', '/voc/GUIDE/list'))
      this.menuGroupList.push(voc)
      let event: MenuGroup = new MenuGroup()
      event.name = '이벤트관리'
      event.iconClass = 'lnb_list-02'
      event.list.push(new Menu('오픈이벤트(24.12.31종료)', '/event/OPEN_EVENT/list'))
      this.menuGroupList.push(event)
    } else {
      //내정보
      let myPageGroup: MenuGroup = new MenuGroup()
      myPageGroup.name = '내정보'
      myPageGroup.iconClass = 'lnb_list-01'
      myPageGroup.list.push(new Menu('MY PAGE', '/mypage/main'))
      //myPageGroup.list.push(new Menu('이용제한이력', '/mypage/ban/history'))
      this.menuGroupList.push(myPageGroup)
      if(user.status == 'ON') { //승인된 사용자만 사용가능
        //링크 관리
        let linkGroup: MenuGroup = new MenuGroup()
        linkGroup.name = '링크 관리'
        linkGroup.iconClass = 'lnb_list-02'
        linkGroup.list.push(new Menu('링크 목록', '/link/list'))
        linkGroup.list.push(new Menu('링크 생성', '/link/product/add'))
        //linkGroup.list.push(new Menu('이벤트 링크 생성', '/link/event/add'))
        this.menuGroupList.push(linkGroup)
      }
      //실적/지급현황
      let accountResult: MenuGroup = new MenuGroup()
      accountResult.name = '실적/지급현황'
      accountResult.iconClass = 'lnb_list-03'
      accountResult.list.push(new Menu('실적현황', '/account/history'))
      accountResult.list.push(new Menu('정산/지급현황', '/account/accounting'))
      this.menuGroupList.push(accountResult)
      //고객의 소리
      let voc: MenuGroup = new MenuGroup()
      voc.name = '고객의 소리'
      voc.iconClass = 'lnb_list-04'
      voc.list.push(new Menu('공지', '/voc/NOTICE/list'))
      voc.list.push(new Menu('문의', '/voc/QNA/list'))
      voc.list.push(new Menu('FAQ', '/voc/FAQ/list'))
      this.menuGroupList.push(voc)
    }
  }
  userId: string
  isAdmin: boolean = true
  menuGroupList: MenuGroup[] = new Array()
  ngOnInit(): void {
    if(this.router.url === '/') {
      if(this.isAdmin) {
        this.router.navigateByUrl('/home')
      } else {
        this.router.navigateByUrl('/mypage')
      }
    }
    if(this.router.url == '/home') { //HOME 예외처리
      this.menuGroupList.find(mg => mg.name == 'HOME').isOpen = true
    } else {
      this.menuGroupList.forEach(mg => {
        mg.list.forEach(m => {
          if(m.link == this.router.url) {
            m.isActive = true
            mg.isOpen = true
          } 
        })
      })
    }
  }
  toggleGroup(group: MenuGroup) {
    group.isOpen = !group.isOpen
  }
  selectMenu(group: MenuGroup, menu: Menu) {
    if(group.isHome) {
      this.router.navigateByUrl('/home')
    } else {
      if(!menu.link) {
        alert("준비중입니다.")
      } else {
        this.router.navigateByUrl(menu.link)
      }
    }
  }
}

export class MenuGroup {
  name: string
  isOpen: boolean = false
  iconClass: string
  isHome: boolean = false
  list: Menu[] = new Array()
}

export class Menu {
  constructor(name: string, link: string) {
    this.name = name
    this.link = link
  }
  name: string
  isActive: boolean = false
  link: string
}